import { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Agenda.module.css';

const AGENDA_ITEMS = [
  { dia: '13 de marzo', url: 'agenda/13_Marzo.png' },
  { dia: '14 de marzo', url: 'agenda/14_Marzo.png' },
];

export default function Agenda() {
  const [activeDay, setActiveDay] = useState(0);
  const item = AGENDA_ITEMS[activeDay];
  const assetUrl = `${process.env.PUBLIC_URL}/${item.url}`;

  return (
    <div className={styles.page}>
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <div className={styles.logoWrapper}>
            <div className={styles.logoCircle}>
              <img
                src={`${process.env.PUBLIC_URL}/logo.gif`}
                alt="4° MasterClass EPI - Juntos Transformando Vidas"
                className={styles.logoImg}
              />
            </div>
          </div>
          <h1 className={styles.titulo}>Agenda MasterClass EPI</h1>
          <Link to="/" className={styles.botonVolver}>
            Volver al inicio
          </Link>
        </div>
      </section>

      <section className={styles.content}>
        <div className={styles.imageWrapper}>
          <div className={styles.tabs}>
            {AGENDA_ITEMS.map((agendaItem, i) => (
              <button
                key={agendaItem.dia}
                type="button"
                className={`${styles.tab} ${i === activeDay ? styles.tabActive : ''}`}
                onClick={() => setActiveDay(i)}
              >
                {agendaItem.dia}
              </button>
            ))}
          </div>
          <img
            src={assetUrl}
            alt={`Agenda ${item.dia}`}
            className={styles.agendaImg}
          />
        </div>
      </section>

      <section className={styles.frase}>
        <div className={styles.fraseContent}>
          <img
            src={`${process.env.PUBLIC_URL}/frase.gif`}
            alt="Más de una década de evidencia, más de un siglo de innovación"
            className={styles.fraseImg}
          />
        </div>
      </section>
    </div>
  );
}
